import { CardHeader } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import CourseDropdown from "../../../../Common/Component/CourseDropdown";
import { quizScores, overAllAverage } from "../../../../Constant";

const QuizResultsCardHeader = ({ overallAverage, selectedCourseId, setSelectedCourseId }) => {
  return (
    <CardHeader className="pb-0">
      <div className="d-flex justify-content-between align-items-center">
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-center">
            <P attrPara={{ className: "square-after f-w-600 header-text-primary m-0" }} >
              {quizScores}
              <i className="fa fa-circle"> </i>
            </P>
            <CourseDropdown isDashboard={true} selectCourse={selectedCourseId} setSelectCourse={setSelectedCourseId} isUser={true} />
          </div>
          <div className="my-3">
            <H4>{overAllAverage}: {overallAverage}%</H4>
          </div>
        </div>
      </div>
    </CardHeader>
  );
};

export default QuizResultsCardHeader;